import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { useUnleashContext } from '@unleash/proxy-client-react';

import { selectUser } from 'store';

import { useAppSelector } from 'hooks';

export const useUnleashContextHook = () => {
  const updateContext = useUnleashContext();

  const { userId } = useAppSelector(selectUser);

  useEffect(() => {
    if (userId) {
      updateContext({ userId });
      datadogRum.setUser({ id: userId });
    } else {
      datadogRum.clearUser();
    }
  }, [userId, updateContext]);
};
